import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { Feedback } from "./feedback";

export function useFeedbackFirestorePersistence(): useFeedbackFirestorePersistenceReturn {
  return useLazyContext(FeedbackFirestorePersistenceContext);
}

export type useFeedbackFirestorePersistenceReturn = {
  createFeedback: (feedback: FirestorePersistenceFeedback) => Promise<void>;
};

export type FirestorePersistenceFeedback = Omit<Feedback, "user"> & {
  userId?: string;
};

export const FeedbackFirestorePersistenceContext =
  createContext<LazyValue<useFeedbackFirestorePersistenceReturn>>(undefined);
